<template>
  <div class="ml-1 w-full">
    <div class="md:flex items-center w-full">
      <p class="  text-xs leading-5 text-gray-500 flex-1">
        <TopicAuthor :message="message" />
      </p>
      <button
        v-if="loggedIn"
        @click="replyToThis"
        class=" hidden text-xs md:flex border border-darkBlue text-darkBlue rounded px-2 py-1 flex-0  hover:block"
      >
        <svg
          class="w-4 h-4 mr-1"
          fill="currentColor"
          viewBox="0 0 20 20"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            d="M7.707 3.293a1 1 0 010 1.414L5.414 7H11a7 7 0 017 7v2a1 1 0 11-2 0v-2a5 5 0 00-5-5H5.414l2.293 2.293a1 1 0 11-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z"
            clip-rule="evenodd"
          ></path>
        </svg>
        Reply
      </button>
    </div>

    <vue-markdown
      :source="message.body"
      :anchorAttributes="{ target: '_blank' }"
      class="mt-2 prose max-w-none text-gray-900 font-medium"
    ></vue-markdown>
    <div class="flex justify-end px-2 ">
      <button
        v-if="loggedIn"
        @click="replyToThis"
        class="md:hidden text-xs flex border border-darkBlue text-darkBlue rounded px-2 py-1 flex-0  text-right mt-4"
      >
        <svg
          class="w-4 h-4 mr-1"
          fill="currentColor"
          viewBox="0 0 20 20"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            d="M7.707 3.293a1 1 0 010 1.414L5.414 7H11a7 7 0 017 7v2a1 1 0 11-2 0v-2a5 5 0 00-5-5H5.414l2.293 2.293a1 1 0 11-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z"
            clip-rule="evenodd"
          ></path>
        </svg>
        Reply
      </button>
    </div>
    <div
      v-if="imageAttachments.length > 0"
      class="flex flex-row flex-wrap justify-start"
    >
      <div
        v-for="attachment in imageAttachments"
        :key="attachment.key"
        class="p-2"
      >
        <attachment-display :attachment="attachment"></attachment-display>
      </div>
    </div>
    <div
      v-if="fileAttachments.length > 0"
      class="flex flex-col justify-start border border-gray-300 rounded-lg p-2"
    >
      <span class="uppercase px-2 pb-2 text-red text-sm font-bold"
        >attachments</span
      >
      <div v-for="attachment in fileAttachments" :key="attachment.key" class="">
        <attachment-display :attachment="attachment"></attachment-display>
      </div>
    </div>
  </div>
</template>

<script>
import AttachmentDisplay from "./AttachmentDisplay";
import VueMarkdown from "vue-markdown";
import TopicAuthor from "./topic/TopicAuthor";
import { mapGetters } from "vuex";

export default {
  name: "TopicMessageDisplay",
  components: {
    TopicAuthor,
    AttachmentDisplay,
    VueMarkdown
  },
  props: {
    message: {
      type: Object,
      required: true
    }
  },
  data: function() {
    return {
      modal: false
    };
  },
  methods: {
    replyToThis() {
      this.$emit("replying-to", this.message);
    }
  },
  computed: {
    ...mapGetters(["loggedIn"]),
    imageAttachments() {
      let images = [];
      if (this.message.attachments) {
        images = this.message.attachments.filter(at =>
          at.key.includes("images/")
        );
      }
      return images;
    },
    fileAttachments() {
      let files = [];
      if (this.message.attachments) {
        files = this.message.attachments.filter(
          at => at.key.includes("images/") === false
        );
      }
      return files;
    }
  }
};
</script>

<style scoped></style>
